import { format } from 'date-fns';
import playersRepository from 'modules/players/domain/repositories/player.repository';
import { Label } from '../styles';

export const loadOptions = async (inputValue: string, tournamentId: number) => {
  const players = await playersRepository.fetchTournamentUsers({
    tournamentId,
    limit: 30,
    offset: 0,
    nameFilter: inputValue,
  });

  return players.map((player) => {
    return {
      label: <Label player={player} />,
      value: {
        ...player,
        birthDate: player.birthDate ? format(new Date(player.birthDate), 'dd.MM.yyyy') : undefined,
      },
    };
  });
};
